import { ButtonType, DialogFooterButtonsWidget, RadioButtonWithLabelGroupWidget } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { localizeRefreshTaskType } from '~src/extractTask/components/extractRefreshDialog/RefreshSelfServiceScheduleDialog';
import { RefreshTaskType } from '~src/schedule/serverApi/requests/CreateSelfServiceScheduleExtractTasksRequest';
import { ChangeScheduleActionService } from '~src/schedule/services/ChangeScheduleAction';
import { cssClass } from '~src/style';

import { ISchedule, ScheduleActions } from '../types/ISchedule';
import { PropsForSchedulePickerActionBody, SchedulePickerActionBody, SchedulePickerProps, SchedulePickerState } from './SchedulePickerActionBody';

export type PropsForCreateExtractRecommendedTab = Omit<SchedulePickerProps, 'scheduledActionType' | 'getSchedules'> & {
  disableIncremental: boolean;
  useDescriptionAsName: boolean;
  schedule: (type: RefreshTaskType, schedule: ISchedule) => void;
  close: () => void;
}

export function CreateExtractTaskRecommendedTab(props: PropsForCreateExtractRecommendedTab) {
  let [schedulePickerState, updateSchedulePickerState] = React.useState(undefined as SchedulePickerState);
  let defaultRefreshType: RefreshTaskType = props.disableIncremental
    ? 'RefreshExtract'
    : 'IncrementExtract';
  let [refreshType, updateRefreshType] = React.useState(defaultRefreshType);
  const schedulePickerProps: PropsForSchedulePickerActionBody = {
    dialogState: schedulePickerState,
    updateDialogState: updateSchedulePickerState,
    scheduledActionType: 'Refresh',
    useDescriptionAsName: props.useDescriptionAsName,
    actionBusy: false,
    doAction: () => props.schedule(refreshType, schedulePickerState.schedule),
    getSchedules: ChangeScheduleActionService.getSchedules(ScheduleActions.Extract),
    description: props.description,
  };

  // Have to compensate for automatic padding in the picker
  const antiMargin = cssClass('recommended', 'antiMargin', {
    marginTop: -20,
  });
  const radioButtons = [{
    label: localizeRefreshTaskType('RefreshExtract'),
    value: 'RefreshExtract',
    testId: 'create-extract-refresh-type-full',
  }, {
    label: localizeRefreshTaskType('IncrementExtract'),
    value: 'IncrementExtract',
    testId: 'create-extract-refresh-type-incremental',
    disabled: props.disableIncremental,
  }];
  return <div className={antiMargin}>
    <SchedulePickerActionBody {...schedulePickerProps} />
    <RadioButtonWithLabelGroupWidget
      title={Messages.extractTasksTypePrompt()}
      label={Messages.extractTasksTypePrompt()}
      buttonList={radioButtons}
      handleChange={value => updateRefreshType(value as RefreshTaskType)}
      checkedIndex={radioButtons.map(b => b.value).indexOf(refreshType)}
    />
    <DialogFooterButtonsWidget
      buttons={[
        {
          handleClick: () => props.close(),
          buttonType: ButtonType.Outline,
          children: Messages.cancel(),
          testId: 'footer-cancel'
        },
        {
          handleClick: () => props.schedule(refreshType, schedulePickerState && schedulePickerState.schedule),
          buttonType: ButtonType.Primary,
          disabled: !schedulePickerState || !schedulePickerState.schedule,
          children: Messages.extractTaskCreateConfirm(),
          testId: 'footer-confirm',
        }]}
      testId="recommended-dialog-footer"
      />
  </div>;
}
